import { ConversionInputStreamSource } from "@arrowsup/platform-dtos";
import { Box, Divider, Typography } from "@mui/material";
import { ReactElement } from "react";
import { useWatch } from "react-hook-form";
import { DialpadSourceConfig } from "./dialpad-source-config";
import { GoogleLsaSourceConfig } from "./google-lsa-source-config";
import { LeapSourceConfig } from "./leap-source-config";

const NoSourceSet: React.FC = () => {
  return <Typography>No source set.</Typography>;
};

export const SourceConfig: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const sourceName: ConversionInputStreamSource | undefined = useWatch({
    name: "source.name",
  });

  const configMap: Record<ConversionInputStreamSource, ReactElement> = {
    dialpad: <DialpadSourceConfig />,
    "leap-lead": <LeapSourceConfig divisions="none" />,
    "leap-appointment-set": <LeapSourceConfig divisions="include" />,
    "leap-job-created": <LeapSourceConfig divisions="include-exclude" />,
    "leap-job-awarded": <LeapSourceConfig divisions="include-exclude" />,
    "google-lsa-lead": <GoogleLsaSourceConfig />,
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Divider sx={{ pb: 2 }}>Source Config</Divider>
      {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        sourceName ? configMap[sourceName] ?? <NoSourceSet /> : <NoSourceSet />
      }
    </Box>
  );
};
